import { css } from '@emotion/react';
import { PropsWithChildren } from 'react';

import { theme } from '../theme';

const styles = {
  description: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    margin: 0;
  `,

  label: css`
    font-size: 13px;
    color: #3f3d3a;
  `,

  content: css`
    display: flex;
    gap: ${theme.spacing.sm};
    flex-wrap: wrap;
    margin-left: 0;
  `,
};

export function DescriptionItem({ label, children }: PropsWithChildren<{ label: string }>) {
  return (
    <dl css={styles.description}>
      <dt css={styles.label}>{label}</dt>
      <dd css={styles.content}>{children}</dd>
    </dl>
  );
}
